

import {storePdp} from "@/store/product-page";
import productPage from "@/api/productPage";

import Vue from 'vue';
import {ObserveVisibility} from 'vue-observe-visibility'
import MuffinLoader from "@/components/Muffin/Loader.vue";
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";

Vue.directive('observe-visibility', ObserveVisibility);

export default {
    storePdp,
    name: 'ComboBlocks',
    components: {
        Single: () => import('@/components/Blocks/Block/Single.vue'),
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        ComboDetail: () => ({
            component: import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ComboDetail.vue'),
            loading: MuffinLoader,
            delay: 200,
            timeout: 3000
        }),
        ProductDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ProductDisplay.vue'),
    },
    props: {
        loadOnCreate: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        if(this.loadOnCreate && this.canCheckCombos) {
            this.load();
        }else{
            this.hideSection = true;
        }
    },
    data() {
        let comboDetailData: any = null;
        let comboListData: Array<any> = [];
        let typeHistory: string = 'modal-my-pack';
        return {
            loading: false,
            modalTitle: '',
            listTitle: '',
            comboDetailData, // combo details modals,
            comboListData, // combo list modal (view more)
            hideSection: false,
            typeHistory
        }
    },
    watch: {},
    methods: {
        async handleComboListModal(blockValue: any, status: boolean = true, addHistory: boolean = true) { // combo list display
            if(!status){
                await history.back();
                return;
            }
            this.listTitle = status ? blockValue.modalTitle : '';

            let comboData   = storePdp.getters['pdpDesktop/comboData'];
            let bundlesList = comboData?.bundlesList??[];
            if(bundlesList.length == 0) {
                return null;
            }

            this.comboListData = status ? productPage.singleBlockFactory(bundlesList, blockValue.modalKey) : [];

            if(status && addHistory){
                this.addHistory(blockValue);
            } 
        },
        addHistory(data: any){
            let loc = window.location;
            let url = loc.protocol+'//'+ loc.host + loc.pathname + (loc.search?loc.search:"") + '#' + this.typeHistory;
            history.pushState({pdpModalOpen: true, key: this.typeHistory, data}, "", url);
        },
        handleComboDetail(item: any) {
            if(item && item.id) {
                this.comboDetailData = item;
                this.comboDetailData.blocksColor = this.blocksColor;
                this.modalTitle = this.kStrings.kCHOOSE_YOUR_PRODUCTS_OPTIONS;
            } else {
                this.comboDetailData = null;
            }
        },
        visibilityRow(isVisible: boolean) {
            if (!this.loadOnCreate && (isVisible && !this.comboBlocks)) {
                this.load();
            }
        },
        setLoading(value: boolean){
            this.loading = value;
            this.$emit('contentLoading', value, 'ComboBlocks');
        },
        initHistoryPopState() { // back on open modals
            window.addEventListener('popstate', event => {
                this.comboListData = [];
                this.comboDetailData = null;
            });

            let open  = history?.state?.pdpModalOpen??false;
            let key   = history?.state?.key??'';
            let data  = history?.state?.data??{};

            if(open && key == this.typeHistory){
                this.handleComboListModal(data,true, false);
            }
        },
        async load() {
            this.setLoading(true);
            await storePdp.dispatch('pdpDesktop/updateComboData', {id: this.groupId, blocksColor: this.blocksColor, limit: 1000});
            if(!this.comboBlocks) {
                this.hideSection = true;
            }

            this.initHistoryPopState();

            this.setLoading(false);
        }
    },
    computed: {
        deviceType(){
            return DeviceType.desktop;
        },
        groupId() {
            return storePdp.getters.GroupId;
        },
        kStrings() {
            return storePdp.getters.kStrings;
        },
        blocksColor() {
            let blocksColor = storePdp.getters.blocksColor;
            if(!blocksColor) { // just in case
                return '#333';
            }

            return blocksColor;
        },
        canCheckCombos() {
            return storePdp.getters['pdpDesktop/canCheckCombos'];
        },
        comboBlocks() {
            const comboData = storePdp.getters['pdpDesktop/comboData'];
            let blockStruct = comboData?.blockStruct??null;
            if(!this.canCheckCombos || !blockStruct) {
                return null;
            }

            // patch OTI
            //return productPage.singleBlockFactory(blockStruct, "PDP_BLOCKS_COUPON_MYPACK_NORMAL");
            let list = productPage.singleBlockFactory(blockStruct, "PDP_BLOCKS_COUPON_MYPACK_PER_BODY");
            return list.length ? list : null;
        },
    },
    mounted() {}

}
